import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import facturasApiService from '../../services/http/facturasApiService'; // Asegúrate de importar el servicio de API

const ModalConfirmarBorrar = ({
  isOpen,
  toggle,
  numFactura,
  onDeleteConfirm,
  update,
  setUpdate,
  endpoint,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState('');

  const { empresaId } = useParams();
  const handleDelete = async () => {
    setIsDeleting(true);
    setDeleteMessage('');

    try {
      // Llamamos a la API para borrar la factura
      let response = await facturasApiService.borrarDetallesFactura({
        headquarter: empresaId,
        idFactura: numFactura,
      });
      if (endpoint === 1) {
        response = await facturasApiService.borrarRelacionFactura({
          headquarter: empresaId,
          idFactura: numFactura,
        });
      }
      // Asume que tienes una función que maneja la eliminación

      if (response.success) {
        setDeleteMessage('Eliminado correctamente.');
        onDeleteConfirm(numFactura); // Llamamos a la función de éxito que notificará al componente padre
      } else {
        setDeleteMessage('Error al eliminar');
      }
    } catch (error) {
      setDeleteMessage('Error al eliminar');
    } finally {
      setIsDeleting(false);
    }

    setUpdate(!update);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Confirmar Borrado</ModalHeader>
      <ModalBody>
        <p>
          ¿Estás seguro de que deseas borrar los detalles de la factura con el número {numFactura}?
        </p>
        {deleteMessage && (
          <p style={{ color: deleteMessage.includes('Error') ? 'red' : 'green' }}>
            {deleteMessage}
          </p>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={isDeleting}>
          Cancelar
        </Button>
        <Button color="danger" onClick={handleDelete} disabled={isDeleting}>
          {isDeleting ? 'Eliminando...' : 'Borrar'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalConfirmarBorrar.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  numFactura: PropTypes.string.isRequired, // El número de factura que se va a borrar
  onDeleteConfirm: PropTypes.func.isRequired,
  update: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  setUpdate: PropTypes.func,
  endpoint: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ModalConfirmarBorrar;
